module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C125",
    attrs: {
      "id": "page_VII"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "C126"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/part0006#page_i"
    }
  }, [_vm._v("Foreword to "), _c('em', [_vm._v("The Cullen Collection")])])]), _vm._v(" "), _c('p', {
    staticClass: "C126"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/part0007#page_v"
    }
  }, [_vm._v("Introduction to "), _c('em', [_vm._v("The Vicar’s Daughter")])])]), _vm._v(" "), _c('p', {
    staticClass: "C127"
  }, [_vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OTE")]), _vm._v(": As the introductions to the 37 volumes of "), _c('em', [_vm._v("The Cullen Collection")]), _vm._v(" form a continuous portrait of George MacDonald’s life, and as many of the introductions contain comprehensive and detailed discussion and analysis of the title in question—its plot, themes, and circumstances of writing—some first-time readers may choose to skip ahead to the story itself, saving the introduction for later, so as not to “spoil the story.”")]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/part0010#page_1"
    }
  }, [_vm._v("1. Introductory")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/part0011#page_8"
    }
  }, [_vm._v("2. A Conversation Between My Parents")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0012#page_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Anticipating Marriage")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0013#page_16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. My Wedding")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0014#page_23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Judy’s Visit")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0015#page_28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. “Good Society”")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0016#page_32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Refuge from the Heat")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0017#page_37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Connie")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0018#page_41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. Connie’s Baby")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0019#page_47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. The Foundling Refound")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0020#page_52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. Wagtail Comes to Honour")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0021#page_57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. A Stupid Chapter")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0022#page_61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13. An Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0023#page_65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14. A Negatived Proposal")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0024#page_68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15. My First Dinner Party")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0025#page_76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16. A Picture")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0026#page_81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17. Rumours")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0027#page_90",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18. A Discovery")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0028#page_98",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19. Miss Clare")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0029#page_107",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20. Miss Clare’s Story")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0030#page_125",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21. Questions and Discussion")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0031#page_130",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22. Lady Bernard")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0032#page_134",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23. My Second Dinner Party")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0033#page_145",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24. The End of the Evening")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0034#page_150",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25. My First Terror")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0035#page_164",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26. What Had Happened")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0036#page_174",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27. Troubles")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0037#page_181",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28. Miss Clare’s Friends")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0038#page_186",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29. Mr, Morley")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0039#page_196",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30. A Strange Text")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0040#page_212",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31. About Percivale")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0041#page_217",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32. My Second Terror")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0042#page_222",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33. Clouds After the Rain")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0043#page_230",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34. Sunshine")])]), _vm._v(" "), _c('p', {
    staticClass: "C128",
    attrs: {
      "id": "page_VIII"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0044#page_235",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35.   What Lady Bernard Thought")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0045#page_238",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36. Mrs. Cromwell Comes")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0046#page_253",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37. Mrs. Cromwell Goes")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0047#page_263",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38. Ancestral Wisdom")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0048#page_269",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39. Child Nonsense")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0049#page_277",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40. Double, Double, Toil and Trouble")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0050#page_283",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41. Roger and Marion")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0051#page_289",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42. My Thoughts About Roger")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0052#page_292",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43. The Dea Ex")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e94be12","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/part0004.vue
// module id = 72
// module chunks = 0